module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/80/assets/images/ba36daf67f6cef9ddbcd31667786376c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_collapse_dark.svg
// module id = 8u+W
// module chunks = 0